export default "__VITE_ASSET__CzA_foK7__"